import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { getStaticPage } from '../lib/static-content';
import { staticHead } from '../lib/seo';

export const Route = createFileRoute('/rss')({
  head: () => {
    const p = getStaticPage('rss');
    return staticHead({ pathname: '/rss', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="rss" />,
});
